<template>
    <v-container>
        <form aria-autocomplete="off">
            <v-layout class="row wrap px-5">
                <v-flex class="xs12">
                    <v-text-field
                        v-model="docTitle"
                        label="Title"
                        :counter="100"
                        :error-messages="errors.collect('title')"
                        v-validate="'required|min:4|max:100'"
                        data-vv-name="title"
                        ref="txtDocTitle"
                        data-cy="txtTitle"
                    ></v-text-field>
                </v-flex>
                <v-flex class="xs12">
                    <v-text-field
                        v-model="fileNumber"
                        label="File Number"
                        :counter="50"
                        :error-messages="errors.collect('fileNumber')"
                        data-vv-name="fileNumber"
                    ></v-text-field>
                </v-flex>

                <v-flex class="xs12">
                    <DistributionSelectWidget
                        @clearLists="clearLists"
                        @addEmailToListWithVars="addEmailToListWithVars"
                    />
                </v-flex>

                <v-flex class="xs12">
                    <v-card class="pa-3">
                        <form @submit.prevent="addEmailToList()">
                            <v-text-field
                                v-model="email"
                                label="Reviewer Email"
                                :counter="50"
                                :error-messages="errors.collect('email')"
                                v-validate="'required|email'"
                                data-vv-name="email"
                                data-cy="txtEmail"
                            ></v-text-field>
                            <v-row class="xs12 px-3">
                                <v-checkbox
                                    class="xs4 pr-5"
                                    v-model="cc"
                                    label="CC (Approval Not Required)"
                                    color="hubblue"
                                    @change="disableSuperApprover"
                                ></v-checkbox>

                                <v-checkbox
                                    class="xs4 pr-5"
                                    v-model="superApprover"
                                    label="Super Approver (Document Considered Fully Approved Once User Approvers)"
                                    color="hubblue"
                                    :disabled="superApproverDisabled"
                                    v-if="showSuperApprover"
                                ></v-checkbox>

                                <v-flex class="justify-right xs4 mt-3">
                                    <v-btn class="hubblue" dark type="submit">
                                        <v-icon class="pr-2">mdi-account-plus</v-icon>
                                        Add Email
                                    </v-btn>
                                </v-flex>
                            </v-row>
                        </form>
                    </v-card>
                </v-flex>

                <v-row class="xs12 pl-3">
                    <v-col cols="12">
                        <v-row class="pr-3">
                            <!-- required -->
                            <v-flex>
                                <v-card class="pa-3 mr-3">
                                    <b>Approver</b>
                                    <v-divider class="mb-2" />
                                    <template v-for="(email, idx) in emailList">
                                        <v-row :key="idx">
                                            <v-btn class="mx-1" icon @click="removeFromList(idx)">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                            <span class="pt-1"
                                                >{{ email.email }}
                                                <span v-if="email.superApprover">
                                                    is Super Approver
                                                </span>
                                            </span>
                                        </v-row>
                                    </template>
                                </v-card>
                            </v-flex>

                            <!-- not required -->
                            <v-flex>
                                <v-card class="pa-3">
                                    <b>CC'd</b>
                                    <v-divider class="mb-2" />
                                    <template v-for="(email, index) in emailListNR">
                                        <v-row :key="index">
                                            <v-btn class="mx-1" icon @click="removeFromListNR(index)">
                                                <v-icon>mdi-close</v-icon>
                                            </v-btn>
                                            <span class="pt-1">{{ email }}</span>
                                        </v-row>
                                    </template>
                                </v-card>
                            </v-flex>
                        </v-row>
                    </v-col>
                </v-row>

                <v-flex class="xs12">
                    <multi-file-upload :files="multiFiles" @fileUploadList="fileListChanged"></multi-file-upload>
                </v-flex>

                <v-flex class="xs12">
                    <v-checkbox
                        v-model="notificationToAll"
                        label="Notify All Approvers When Document Is Approved"
                    ></v-checkbox>
                </v-flex>

                <v-flex class="xs12">
                    <v-textarea outline v-model="comment" label="Optional Message" auto-grow rows="1"></v-textarea>
                </v-flex>

                <v-flex class="xs12">
                    <v-btn
                        color="hubblue"
                        class="white--text"
                        @click="save"
                        :loading="loading"
                        :disabled="loading"
                        data-cy="btnRegister"
                        >Send</v-btn
                    >
                </v-flex>
            </v-layout>
        </form>
    </v-container>
</template>

<script>
import axios from 'axios'
import multiFileUpload from '../../components/Helpers/multiFileUpload'
import DistributionSelectWidget from '../../components/Helpers/DistributionSelectWidget'
import { authHeader } from '../_helpers'

export default {
    components: {
        'multi-file-upload': multiFileUpload,
        DistributionSelectWidget
    },
    $_veeValidate: {
        validator: 'new' // give me a new validator each time.
    },
    data() {
        return {
            loading: false,
            snackbar: false,
            snackbarMessage: null,
            snackbarContext: '',
            companyId: null,
            docTitle: null,
            multiFiles: [],
            revision: 0,
            documentURL: '',
            licenseDocument: '',
            comment: '',
            fileNumber: '',

            email: '',
            cc: false,
            superApprover: false,
            showSuperApprover: true,
            superApproverDisabled: false,

            emailList: [],
            emailListNR: [],
            emailData: {},

            notificationToAll: false
        }
    },

    methods: {
        disableSuperApprover(cc) {
            if (cc) {
                this.superApprover = false
                this.superApproverDisabled = true
            } else {
                this.superApproverDisabled = false
            }
        },
        removeFromList(index) {
            let emailListData = this.emailList[index]
            if (this.emailData[emailListData.email].superApprover) {
                this.superApproverDisabled = false
                this.superApprover = false
                this.showSuperApprover = true
            }
            delete this.emailData[emailListData.email]
            this.emailList.splice(index, 1)
        },
        removeFromListNR(index) {
            let emailAddress = this.emailListNR[index]
            delete this.emailData[emailAddress]
            this.emailListNR.splice(index, 1)
        },
        addEmailToList() {
            this.$validator
                .validate('email', this.email)
                .then(validated => {
                    if (validated) {
                        let index = this.emailList.findIndex(record => {
                            // missed .email caused index always be -1,fixed
                            return record.email === this.email
                        })
                        let index2 = this.emailListNR.findIndex(record => {
                            return record.email === this.email
                        })

                        if (index < 0 && index2 < 0) {
                            if (this.cc === false) {
                                this.emailList.push({
                                    email: this.email,
                                    superApprover: this.superApprover
                                })
                            } else {
                                this.emailListNR.push(this.email)
                            }
                            this.emailData[this.email] = {
                                cc: this.cc,
                                superApprover: this.superApprover
                            }
                        } else {
                            let snackbarParams = {
                                message: 'Email already in the list.',
                                context: 'orange'
                            }

                            this.$store.commit('showSnackbar', snackbarParams)
                        }
                        this.email = ''
                        this.cc = false
                        //only want one super approver per document, hide that option if one was added
                        if (this.superApprover) {
                            this.superApprover = false
                            this.showSuperApprover = false
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                    return false
                })
        },
        fileListChanged(newFileList) {
            this.multiFiles = newFileList
        },
        createDoc() {
            this.loading = true
            const app = this
            let snackbarParams

            if (app.multiFiles.length > -1) {
                let formData = new FormData()
                formData.append('companyId', app.$store.state.authentication.loggedInUser.companyId)
                formData.append('userId', app.$store.state.authentication.loggedInUser.userId)
                formData.append('docTitle', app.docTitle)
                for (let i = 0; i < app.multiFiles.length; i++) {
                    formData.append('multiFiles', app.multiFiles[i])
                }
                formData.append('replyTo', app.$store.state.authentication.loggedInUser.email)
                formData.append('emailData', JSON.stringify(app.emailData))
                formData.append('comment', app.comment)
                formData.append('fileNumber', app.fileNumber)
                formData.append('originUrl', window.location.origin)
                formData.append('notificationToAll', app.notificationToAll)
                let headers = {
                    headers: {
                        Authorization: JSON.parse(localStorage.getItem('user')),
                        'Content-Type': 'multipart/form-data'
                    }
                }
                axios
                    .post(app.$store.state.docUrl, formData, headers)
                    .then(response => {
                        app.loading = false
                        snackbarParams = {
                            message: response.data,
                            context: 'success'
                        }
                        app.$store.commit('showSnackbar', snackbarParams)

                        this.$router.push({ name: 'Dashboard' })
                    })
                    .catch(error => {
                        console.log(error)
                        app.loading = false
                        snackbarParams = {
                            message: error.response.data,
                            context: 'error'
                        }
                        app.$store.commit('showSnackbar', snackbarParams)
                    })
            }
        },
        save() {
            let app = this
            app.$validator
                .validate('title', this.docTitle)
                .then(validated => {
                    if (
                        validated &&
                        app.multiFiles.length > 0 &&
                        app.multiFiles.length <= 30 &&
                        JSON.stringify(app.emailData) !== '{}'
                    ) {
                        app.createDoc()
                    } else {
                        let snackbarParams = {
                            message:
                                'Failed to create document, check invalid fields, at least one email and at least one file.',
                            context: 'error'
                        }
                        app.$store.commit('showSnackbar', snackbarParams)
                    }
                })
                .catch(() => {
                    return false
                })
        },
        addEmailToListWithVars(email, cc, superApprover) {
            if (cc === false) {
                this.emailList.push({
                    email,
                    superApprover
                })
            } else {
                this.emailListNR.push(email)
            }
            this.emailData[email] = {
                cc,
                superApprover
            }

            //only want one super approver per document, hide that option if one was added
            if (superApprover) {
                this.superApprover = false
                this.showSuperApprover = false
            }
        },
        clearLists() {
            this.email = ''
            this.cc = false
            this.emailList = []
            this.emailListNR = []
            this.emailData = {}
        }
    }
}
</script>
